var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaxe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.946 31.9908L55.0724 23.9204L0 0.00424957H63.9707L127.946 31.9951",
    fill: "#FBC707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.945 31.9908L202.488 25.5891L255.891 0.00424957H191.916L127.945 31.9951",
    fill: "#FBC707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.945 223.905L197.481 226.408L255.891 255.892H191.916L127.945 223.9",
    fill: "#F68712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.946 223.905H57.8538L0 255.892H63.9707L127.946 223.9",
    fill: "#F25C19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9853 127.949V195.256L0 255.892V191.921L31.9853 127.947",
    fill: "#FFF200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9853 127.949L26.7016 61.1916L0 0.00435638V63.9746L31.9853 127.948",
    fill: "#FFF200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9 127.949L230.858 57.8539L255.891 0.00435638V63.9746L223.9 127.948",
    fill: "#F1471D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9 127.949L229.746 203.044L255.891 255.892V191.921L223.9 127.947",
    fill: "#F1471D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00435638L127.946 31.9909L107.363 113.483L31.9853 127.949L0 0.0111084",
    fill: "#FAB20B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.891 0.00435638L223.901 127.949L137.959 112.366L127.945 31.987L255.891 0.0111084",
    fill: "#F47216"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.891 255.892L127.945 223.905L142.409 139.078L223.9 127.955L255.891 255.884",
    fill: "#F25C19"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 255.892L31.9853 127.949L109.032 145.191L127.946 223.905L0 255.884",
    fill: "#F89C0E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.945 31.9907L31.9844 127.949L127.945 223.905L223.9 127.949L127.945 31.995",
    fill: "#F68712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaxe);
export default __webpack_public_path__ + "static/media/haxe.10a910ffc452fd5a0e87425ce5ee0404.svg";
export { ForwardRef as ReactComponent };